import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ViewEncapsulation,
  OnInit
} from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderServiceService } from './loader-service.service';
import { CanonicalTagsService } from './canonical-tags.service';

@Component({
  selector: 'takeoff-group-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements AfterViewChecked, OnInit {
  title = 'takeoff-projects-v2';
  isLoading: Subject<boolean>;
  constructor(
    private loaderService: LoaderServiceService,
    private cdRef: ChangeDetectorRef,
    private canonicalTagService: CanonicalTagsService
  ) {}

  ngAfterViewChecked() {
    this.isLoading = this.loaderService.isLoading;
    this.cdRef.detectChanges();
  }

  ngOnInit() {
    console.log('AppComponent initialized');
    this.canonicalTagService.init();
  }
}
